module.exports = __webpack_public_path__ + "static/bslGov_img3-731700af3740706711db493913973218.png";